<template>
    <div>
        <div class="seccttin">
            <div class="stip1">
                <h4>How to find my order ID?</h4>
                <p>Step 1: Login your Amazon account and click “Your Order” in Account &amp; Lists Page:</p>
                <img src="" alt="">
                <p>Step 2: Click “Order details” on the right order:</p>
                <img src="" alt="">
                <p>Step 3: You will see your order ID:</p>
                <img src="" alt="">
                <p>Step 4: Please complete all the content within an hour.</p>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    data() {
        return {
            
        }
    },
}
</script>
<style lang="less" scoped>
    .stip1{
        // margin: 0 30%;
        margin: 0 auto;
        margin-left: 30%;
        color: #747474;
        padding-bottom: 50px;
        box-sizing: border-box;
        h4{
            font-size: 22px;
            margin: 0 0 20px;
            margin-top: 100px;
            color: #747474;
        }
        p{
            margin-bottom: 20px;
            color: #747474;
        }
        img{
            margin-bottom: 100px;
        }
    }
</style>